import { render, staticRenderFns } from "./compareconsumption.vue?vue&type=template&id=709c5b0a&scoped=true&"
import script from "./compareconsumption.vue?vue&type=script&lang=js&"
export * from "./compareconsumption.vue?vue&type=script&lang=js&"
import style0 from "./compareconsumption.vue?vue&type=style&index=0&id=709c5b0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709c5b0a",
  null
  
)

export default component.exports